document.addEventListener("DOMContentLoaded", function () {
    let mobileSwiper = null;
  
    function initMobileSwiper() {
      const slider = document.querySelector('#rubbit-in-action-slider');
      if (!slider) return;
      
      const activePanel = slider.closest('.tab-panel');
      if (activePanel && !activePanel.classList.contains('active')) {
        return; // Don't initialize if tab is not active
      }
      
      if (window.innerWidth < 990 && !mobileSwiper) {
        mobileSwiper = new Swiper('#rubbit-in-action-slider', {
          slidesPerView: 3.7,
          spaceBetween: 10,
          slidesOffsetBefore: 13,
          slidesOffsetAfter: 13,
          loop: true,
        });
      }
  
      if (window.innerWidth >= 990 && mobileSwiper) {
        mobileSwiper.destroy(true, true);
        mobileSwiper = null;
      }
    }
  
    // Only initialize swiper if rubbit-in-action tab is active on load
    const rubbitPanel = document.getElementById('rubbit-in-action-panel');
    if (rubbitPanel && rubbitPanel.classList.contains('active')) {
      initMobileSwiper();
    }
    window.addEventListener("resize", initMobileSwiper);
  
  
    // ----------------------------
    // VIDEO PLAY / PAUSE HANDLING
    // ----------------------------
  
    const slides = document.querySelectorAll(".rubbit-video-slide");
    slides.forEach((slide) => {
      const video = slide.querySelector("video");
      const playBtn = slide.querySelector(".play_button");
  
      if (!video || !playBtn) return;
  
      // Play video on play-button click
      playBtn.addEventListener("click", function () {
        // Pause all other videos
        document.querySelectorAll(".rubbit-video-slide video").forEach((v) => {
          if (v !== video) {
            v.pause();
            v.currentTime = 0;
            v.closest(".rubbit-video-slide")
              .querySelector(".play_button")
              .style.display = "flex";
          }
        });
  
        playBtn.style.display = "none";
        video.play();
      });
  
      // Pause on clicking the video
      video.addEventListener("click", function () {
        if (!video.paused) {
          video.pause();
          playBtn.style.display = "flex";
        }
      });
  
      // When video ends, show button again
      video.addEventListener("ended", function () {
        playBtn.style.display = "flex";
        video.currentTime = 0;
      });
    });

    // ----------------------------
    // ACCORDION FUNCTIONALITY
    // ----------------------------
    
    function initAccordion() {
      const accordionButtons = document.querySelectorAll('.accordion-section .accordion-button');
      
      if (accordionButtons.length === 0) {
        return;
      }
      
      accordionButtons.forEach(button => {
        // Skip if already initialized
        if (button.dataset.accordionInitialized === 'true') {
          return;
        }
        button.dataset.accordionInitialized = 'true';
        
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const targetAccordion = this.getAttribute('data-accordion');
          const targetPanel = document.getElementById(`${targetAccordion}-panel`);
          
          if (!targetPanel) {
            return;
          }
          
          const isCurrentlyActive = this.classList.contains('active');
          
          // Toggle current accordion
          if (isCurrentlyActive) {
            // Close current accordion
            this.classList.remove('active');
            targetPanel.style.maxHeight = '0px';
            targetPanel.classList.remove('active');
            
            // Destroy swiper if closing rubbit-in-action
            if (targetAccordion === 'rubbit-in-action' && mobileSwiper) {
              mobileSwiper.destroy(true, true);
              mobileSwiper = null;
            }
          } else {
            // Open clicked accordion
            this.classList.add('active');
            targetPanel.classList.add('active');
            
            // Calculate dynamic height
            const contentHeight = targetPanel.scrollHeight;
            targetPanel.style.maxHeight = contentHeight + 'px';
            
            // Initialize swiper if opening rubbit-in-action
            if (targetAccordion === 'rubbit-in-action') {
              setTimeout(() => {
                if (mobileSwiper) {
                  mobileSwiper.destroy(true, true);
                  mobileSwiper = null;
                }
                initMobileSwiper();
                
                // Recalculate height after swiper initialization
                const newHeight = targetPanel.scrollHeight;
                targetPanel.style.maxHeight = newHeight + 'px';
              }, 100);
            }
          }
        });
      });
    }
    
    initAccordion();
    
    // Set initial heights for active accordions
    function setInitialAccordionHeights() {
      const activePanels = document.querySelectorAll('.accordion-section .accordion-panel.active');
      activePanels.forEach(panel => {
        const contentHeight = panel.scrollHeight;
        panel.style.maxHeight = contentHeight + 'px';
      });
    }
    
    // Set initial heights after DOM is ready
    setTimeout(setInitialAccordionHeights, 100);
    
    // Recalculate heights on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const activePanels = document.querySelectorAll('.accordion-section .accordion-panel.active');
        activePanels.forEach(panel => {
          const contentHeight = panel.scrollHeight;
          panel.style.maxHeight = contentHeight + 'px';
        });
      }, 250);
    });

    // ----------------------------
    // BUY NOW BUTTON HANDLING (BFCM Specific)
    // ----------------------------
    
    // Separate Buy Now handler for BFCM module
    function handleBFCMBuyNow(button) {
      const variantId = document.querySelector('#product-form input[name="id"]')?.value;
      const sellingPlanId = button.getAttribute('data-selling-plan-id');
      
      if (!variantId) {
        console.error('Variant ID not found');
        return;
      }
      
      // Store original text
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent.trim();
      }
      const originalText = button.dataset.originalText;
      
      // Set loading state
      button.disabled = true;
      button.style.opacity = '0.6';
      button.style.cursor = 'not-allowed';
      button.textContent = 'Processing...';
      
      // Create item object
      const item = {
        id: variantId,
        quantity: 1
      };
      
      // Add selling plan if subscription is enabled
      if (sellingPlanId) {
        item.selling_plan = sellingPlanId;
      }
      
      const items = [item];
      
      // Add to cart and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then(data => {
        // Show success state briefly before redirect
        button.textContent = 'Redirecting...';
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 500);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Show error state
        button.textContent = 'Error - Try Again';
        button.style.opacity = '1';
        
        // Reset button state after 3 seconds
        setTimeout(() => {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          button.textContent = originalText;
        }, 3000);
      });
    }
    
     // Separate Add to Cart handler for BFCM module
    function handleBFCMAddToCart(button, event) {
      event.preventDefault();
      
      const variantId = document.querySelector('#product-form input[name="id"]')?.value;
      const sellingPlanId = button.getAttribute('data-selling-plan-id');
      
      if (!variantId) {
        console.error('Variant ID not found');
        return;
      }
      
      // Check if button has data-bfcm-add-to-cart attribute
      const redirectToCheckout = button.hasAttribute('data-direct-to-checkout');
      
      // Store original text
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent.trim();
      }
      const originalText = button.dataset.originalText;
      
      // Set loading state
      button.disabled = true;
      button.style.opacity = '0.6';
      button.style.cursor = 'not-allowed';
      if(redirectToCheckout) {
        button.textContent = 'Redirecting...';
      } else {
        button.textContent = 'Adding...';
      }
      
      
      // Create item object
      const item = {
        id: variantId,
        quantity: 1
      };
      
      // Add selling plan if subscription is enabled
      if (sellingPlanId) {
        item.selling_plan = sellingPlanId;
      }
      
      const items = [item];
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then(data => {
        // Fetch complete cart data to get item_count
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cartData => {
        // Update cart drawer
        if (window.updateCart) {
          window.updateCart(cartData);
        }
        // Update cart count if available
        if (typeof window.updateCartCount === 'function') {
          window.updateCartCount();
        }
        
        // Check if button has data-bfcm-add-to-cart attribute
        if (redirectToCheckout) {
          // Redirect to checkout if button doesn't have data-bfcm-add-to-cart
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 500);
        } else {
          // Show success state
          button.textContent = 'Added!';
          
          // Open cart drawer
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
          
          // Reset button state after a brief delay
          setTimeout(() => {
            button.disabled = false;
            button.style.opacity = '1';
            button.style.cursor = 'pointer';
            button.textContent = originalText;
          }, 2000);
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Show error state
        button.textContent = 'Error - Try Again';
        button.style.opacity = '1';
        
        // Reset button state after 3 seconds
        setTimeout(() => {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          button.textContent = originalText;
        }, 3000);
      });
    }
    
    // Initialize BFCM Buy Now buttons
    const bfcmBuyNowButtons = document.querySelectorAll('[data-bfcm-buy-now]');
    bfcmBuyNowButtons.forEach(button => {
      if (button.dataset.bfcmBuyNowInitialized === 'true') {
        return;
      }
      button.dataset.bfcmBuyNowInitialized = 'true';
      button.addEventListener('click', function(e) {
        e.preventDefault();
        if (button.disabled || button.classList.contains('disabled')) {
          return;
        }
        handleBFCMBuyNow(button);
      });
    });
    
    // Initialize BFCM Add to Cart buttons
    const bfcmAddToCartButtons = document.querySelectorAll('[data-bfcm-add-to-cart]');
    bfcmAddToCartButtons.forEach(button => {
      if (button.dataset.bfcmAddToCartInitialized === 'true') {
        return;
      }
      button.dataset.bfcmAddToCartInitialized = 'true';
      button.addEventListener('click', function(e) {
        if (button.disabled || button.classList.contains('disabled')) {
          e.preventDefault();
          return;
        }
        handleBFCMAddToCart(button, e);
      });
    });
  });

